export default {
    install() {
        // disable this functionality for now. its buggy
        return;

        if (typeof window === 'undefined') return;

        const isStandalone = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone;

        if (!isStandalone) return;

        const addNativeLink = (el) => {
            if (el.tagName !== 'A') return;
            if (el._nativeLinkAttached) return;
            let touchMoved = false;

            el.addEventListener('touchstart', (e) => {
                touchMoved = false;
                e.preventDefault();
            });

            el.addEventListener('touchmove', () => {
                touchMoved = true;
            });

            el.addEventListener('touchend', () => {
                if (!touchMoved) {
                    el.click();
                }
            });

            el._nativeLinkAttached = true;
        }

        const observer = new MutationObserver((mutations) => {
            mutations.forEach(mutation => {
                mutation.addedNodes.forEach(node => {
                    if (node.nodeType !== 1) return;

                    if (node.tagName === 'A') {
                        addNativeLink(node);
                    }

                    node.querySelectorAll?.('a').forEach(addNativeLink);
                });
            });
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });

        document.querySelectorAll('a').forEach(addNativeLink);
    }
  }
